import React from 'react'
import LayoutContainer from './shared/LayoutContainer'
import Text from './shared/Text'

const Organisation = () => {
  return (
    <LayoutContainer>
      <h2>Über uns</h2>
      <h3>Die Apostelgeschichte ... (Fortsetzung)</h3>
      <Text>
        Wir sind eine kleine Gruppe von Christen aus verschiedenen Kirchen und Gemeinden.<br/>
        Seit mehreren Jahren treffen wir uns regelmäßig jede Woche.
      </Text>
      <Text>
        Wir beten gemeinsam, dass der Wille Gottes unter uns geschieht.<br/>
        Wir beten um Heilung für Kranke, um Befreiung und um Gottes Segen, 
        nicht nur für uns, sondern auch für unsere Wohnorte, für unser Land und für alles, 
        was Gottes Geist uns aufs Herz legt.
      </Text>
      <Text>
        Wir glauben, dass Gott uns in ein Netzwerk von Gruppen einbaut, 
        das er zur Zeit an vielen Orten in der ganzen Welt aufbaut.
      </Text>
      <Text>
        Wir glauben, dass Jesus bald wiederkommt.
      </Text>
      <h3> Unsere Ziele und Schwerpunkte ...</h3>
      <Text>
      <ul>
      <li> Wir glauben an Jesus Christus, den Sohn Gottes und Erlöser der Welt.</li>
      <li> Wir bereiten uns durch Heiligung und Buße auf seine Wiederkunft vor.</li>
      <li> Wir erwarten, dass noch mehr Heilungen und Befreiungen unter uns passieren, 
           so wie sie in der Bibel beschrieben sind.</li>
      <li> <i>Mount Olives</i> (der Ölberg in Jerusalem) ist der Ort, an dem Jesus 
          sich oft aufhielt um zu beten und Gottes Nähe zu suchen.<br />
          Unsere Treffen sollen ein solcher Ort des Gebets sein, daher der Name.</li>
      <li> Wir haben einen apostolischen und prophetischen Auftrag, zusammen mit anderen 
          Hausgemeinden und Gebetsgruppen, die der heilige Geist zur Zeit herausruft, 
          ein Gefäß zu sein, damit Gottes Herrlichkeit unter uns sichtbar werden kann.</li>
      <li> Der Name <i>Mt.Olives</i> steht auch für unsere Beziehung zu Israel als dem
          von Gott auserwählten Volk und Land.</li>
      </ul>
    </Text>        
    </LayoutContainer>
  )
}

export default Organisation



// WEBPACK FOOTER //
// ./src/components/Organization.js